import { getLaunchPromotion, LaunchPromotionResponse } from './api/promotionsApi';

const CACHE_MS = 30_000;
let cachedPromo: LaunchPromotionResponse | null = null;
let cachedAt = 0;
let pending: Promise<LaunchPromotionResponse> | null = null;

export const readLaunchPromotion = (): LaunchPromotionResponse | null =>
  cachedPromo && Date.now() - cachedAt < CACHE_MS ? cachedPromo : null;

export const loadLaunchPromotion = (): Promise<LaunchPromotionResponse> => {
  const cached = readLaunchPromotion();
  if (cached) return Promise.resolve(cached);
  if (pending) return pending;
  pending = getLaunchPromotion()
    .then((data) => {
      cachedPromo = data;
      cachedAt = Date.now();
      return data;
    })
    .finally(() => {
      pending = null;
    });
  return pending;
};
